import { twcls } from '@utils/twcls';
import type { FC } from 'react';

interface ProductImage18PlusProps {
  image?: string;
  isSmallText?: boolean;
}

const ProductImage18Plus: FC<ProductImage18PlusProps> = ({
  image,
  isSmallText
}) => (
  <div
    className={twcls(
      'relative flex flex-col items-center justify-center w-full h-full overflow-hidden rounded-2xl',
      isSmallText && 'mb-3'
    )}
  >
    <div className='absolute z-10 text-center'>
      <p
        className={twcls(
          'text-[50px] font-medium sm:text-[45px]',
          isSmallText && 'text-3xl sm:text-xl'
        )}
      >
        {' '}
        18+
      </p>
      <p
        className={twcls(
          'text-xl sm:text-lg',
          isSmallText && 'text-base sm:text-xs'
        )}
      >
        Товар для взрослых
      </p>
    </div>
    {image && (
      <img
        src={image}
        alt='18+'
        className='object-contain w-full h-full blur-3xl'
      />
    )}
  </div>
);

export default ProductImage18Plus;
